const t=(t,e)=>{if(!t||"string"!=typeof t&&"number"!=typeof t)return e;const r=Number(t);return isNaN(r)?e:r};export{t as default};
